import { defineQuery, enterQuery, exitQuery, entityExists, } from "bitecs";
import { Rigidbody, SnapFrame, NetworkedMediaFrame} from "../bit-components";
import {
  HeldRemoteLeft,
  HeldRemoteRight,
  MediaContentBounds,
  Networked
} from "../bit-components";

import {
  Matrix4,
  Quaternion,
  Vector3
} from "three";
import { setMatrixWorld } from "../utils/three-utils";
import { anyEntityWith } from "../utils/bit-utils";
import { takeSoftOwnership } from "../utils/take-soft-ownership";

// let isLeftClickPressed = false;
// let isLeftClickPressedAutoSnap = false;

// // Track mouse state natively
// window.addEventListener('mousedown', (event) => {
//     if (event.button === 0) { // 0 is the left mouse button
//         isLeftClickPressed = true;
//         isLeftClickPressedAutoSnap = true;
//     }
// });

// window.addEventListener('mouseup', (event) => {
//     if (event.button === 0) { // 0 is the left mouse button
//         setTimeout(() => {
//             isLeftClickPressed = false;
//         }, 50)
//         setTimeout(() => {
//             isLeftClickPressedAutoSnap = false;
//         }, 50)
//     }
// });

let grabbedObject = null;
let releaseTimeout = null;
let lastHeldObject = null;


const mediaFramesQuery = defineQuery([SnapFrame]);
const takeOwnershipOnTimeout = new Map();
// Centralized registry to track captured eids and their objeids
const capturedEids = new Map(); // Map<eid, objeid>

// Map to track which frame has captured which eid
// Map to track which frame has captured which eids
const frameToEids = new Map(); // Map<frameEid, Set<eid>>

export function snapWallSystem(world, physicsSystem) {
    const enteredMediaFramesQuery = enterQuery(mediaFramesQuery);
    enteredMediaFramesQuery(world).forEach(eid => {

        if (Networked.owner[eid] === APP.getSid("reticulum")) {
            takeOwnershipOnTimeout.set(
            eid,
            setTimeout(() => {
                if (Networked.owner[eid] === APP.getSid("reticulum")) {
                takeSoftOwnership(world, eid);
                }
                takeOwnershipOnTimeout.delete(eid);
            }, 10000)
            );
        }

        const guideObj = world.eid2obj.get(SnapFrame.guide[eid]);
        guideObj.visible = false;

        const frameObj = world.eid2obj.get(eid);
        frameObj.add(guideObj);
    });

    const exitedMediaFramesQuery = exitQuery(mediaFramesQuery);

    exitedMediaFramesQuery(world).forEach(eid => {
        const timeout = takeOwnershipOnTimeout.get(eid);
        if (timeout) {
        clearTimeout(timeout);
        takeOwnershipOnTimeout.delete(eid);
        }
    });

    function roundToNearestQuarter(number) {
        return Math.round(number * 4) / 4;
    }

    function createBoundingBoxFromObject(obj) {
        return new THREE.Box3().setFromObject(obj);
    }

    function scaleForAspectFit(containerSize, itemSize) {
    return Math.min(containerSize[0] / itemSize.x, containerSize[1] / itemSize.y, containerSize[2] / itemSize.z);
    }

    function isCaptured(eid) {
        return capturedEids.has(eid);
    }


    const snapToFrame = (() => {
    const avatarRig = document.querySelector('#avatar-rig').object3D;
    const avatarPos = new Vector3();
    const avatarQuat = new Quaternion();
    const avatarScale = new Vector3();

    const framePos = new Vector3();
    const frameQuat = new Quaternion();
    const frameScale = new Vector3();
    const m4 = new Matrix4();
    const contentBounds = new Vector3();

    return (world, frame, target) => {
        
        let frameObj = world.eid2obj.get(frame);
        let planeObject = null;

        frameObj.traverse(function(child) {
            if (child.geometry instanceof THREE.PlaneGeometry) {
                planeObject = child;
            }
        });

        if (planeObject) {
            frameObj = planeObject;
        }
        const targetObj = world.eid2obj.get(target);
        const targetPos = new Vector3();
        const targetQuat = new Quaternion();
        const targetScale = new Vector3();
        avatarRig.matrixWorld.decompose(avatarPos, avatarQuat, avatarScale);

        const boundingBox = createBoundingBoxFromObject(frameObj);

        frameObj.updateMatrices();
        frameObj.matrixWorld.decompose(framePos, frameQuat, frameScale);
        
        targetObj.matrixWorld.decompose(targetPos, targetQuat, targetScale);
        contentBounds.fromArray(MediaContentBounds.bounds[target]);
        let threshold = 0.1;

        let closestToAvatar = (frameBoundingBoxMin, frameBoundingBoxMax, avatarAxis) => {
            let frameAxisMin = frameBoundingBoxMin;
            let frameAxisMax = frameBoundingBoxMax;

            let diffMin = Math.abs(frameAxisMin - avatarAxis);
            let diffMax = Math.abs(frameAxisMax - avatarAxis);

            return diffMin < diffMax ? frameAxisMin : frameAxisMax;
        }

        let newSnappedVectorX = Math.abs(boundingBox.max.x - boundingBox.min.x) < threshold ? closestToAvatar(boundingBox.min.x, boundingBox.max.x, avatarPos.x) : roundToNearestQuarter(Math.max(boundingBox.min.x, Math.min(boundingBox.max.x, targetPos.x)));
        let newSnappedVectorY = Math.abs(boundingBox.max.y - boundingBox.min.y) < threshold ? closestToAvatar(boundingBox.min.y, boundingBox.max.y, avatarPos.y) : roundToNearestQuarter(Math.max(boundingBox.min.y, Math.min(boundingBox.max.y, targetPos.y)));
        let newSnappedVectorZ = Math.abs(boundingBox.max.z - boundingBox.min.z) < threshold ? closestToAvatar(boundingBox.min.z, boundingBox.max.z, avatarPos.z): roundToNearestQuarter(Math.max(boundingBox.min.z, Math.min(boundingBox.max.z, targetPos.z)));


        let newSnappedVector = new Vector3(newSnappedVectorX, newSnappedVectorY, newSnappedVectorZ );

        setMatrixWorld(
            targetObj,
            m4.compose(
                newSnappedVector,
                frameQuat,
                targetObj.scale
            )
        );
    };
    })();

    function display(world, frame, grabbing) {
        const frameObj = world.eid2obj.get(frame);
        frameObj.children[0].visible = !!grabbing;
    }

    const objectsIds = window.APP.scene.systems["listed-media"].els.map(el => el.eid);

    function getCapturableEntities(world, physicsSystem, frame) {
        const capturables = new Set();
        try {
            const collisions = physicsSystem.getCollisions(Rigidbody.bodyId[frame]);

            for (let i = 0; i < collisions.length; i++) {
                const bodyData = physicsSystem.bodyUuidToData.get(collisions[i]);
                const eid = bodyData.object3D.eid;

                // Only capture entities whose eid is part of objectsIds
                if (objectsIds.includes(eid)) {
                    capturables.add(eid);
                }
            }
        } catch (e) {
            console.error(`Error in getCapturableEntities: ${e}`);
        }

        return capturables;
    }

    const mediaFrames = mediaFramesQuery(world);

    for (let i = 0; i < mediaFrames.length; i++) {
        let objeid = (anyEntityWith(APP.world, HeldRemoteLeft) || anyEntityWith(APP.world, HeldRemoteRight))
        let eid2obj = window.APP.world.eid2obj.get(objeid);
        
        if(eid2obj && eid2obj.name === "Camera Tool") {
            objeid = null;
        }

        if (eid2obj && eid2obj.el && eid2obj.el.classList.contains("pen")) {
            objeid = null;
        }

        if(objeid) {
            lastHeldObject = objeid;
            const pinnable = window.APP.world.eid2obj.get(lastHeldObject).el?.components['pinnable']?.data.pinned;
            if(pinnable) {
                lastHeldObject = null;
            }
        }


        const frame = mediaFrames[i];
        const capturedEidSet = frameToEids.get(frame) || new Set();

        // Iterate over a copy to allow modifications during iteration
        const capturedEidsArray = Array.from(capturedEidSet);

        capturedEidsArray.forEach(capturedEid => {
            const isCapturedColliding = getCapturableEntities(world, physicsSystem, frame).has(capturedEid);
            if (isCapturedColliding && lastHeldObject === capturedEid) {
                // Object is still colliding with the wall, keep it snapped
                snapToFrame(world, frame, capturedEid);
            } else {
                // Object is no longer colliding with the wall, release it  
                // world.eid2obj.get(capturedEid).el.setAttribute("floaty-object", {modifyGravityOnRelease: true})
                capturedEids.delete(capturedEid);
                capturedEidSet.delete(capturedEid);
            }
        });

        // Automatically detect objects near the frame, but only for objects in objectsIds
        const capturables = getCapturableEntities(world, physicsSystem, frame);

        if (capturables.size > 0) {
            capturables.forEach(capturable => {
                if (!isCaptured(capturable)) {
                    // Lock the eid by adding it to the centralized registry
                    capturedEids.set(capturable, frame);

                    // Add to frameToEids
                    const eidSet = frameToEids.get(frame) || new Set();
                    eidSet.add(capturable);
                    frameToEids.set(frame, eidSet);

                    // snapToFrame(world, frame, capturable);
                }
            });
        }


        // Handle grabbing logic with timeout
        if (objeid) {
            grabbedObject = objeid;

            if (releaseTimeout) {
                clearTimeout(releaseTimeout);
                releaseTimeout = null;
            }

            releaseTimeout = setTimeout(() => {
                // Reset the grabbed object after 60ms
                grabbedObject = null;
            }, 60); // Clear object after 60ms
        }

        display(world, frame, objeid);
    }
}